module.exports = __webpack_public_path__ + "img/top-agente.3dbda49f.png";